import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
const { FiHome, FiPlus, FiGrid, FiShoppingBag, FiUser } = FiIcons;

const tabs = [
  { id: 'timeline',  icon: FiHome,         label: 'Timeline' },
  { id: 'routines',  icon: FiGrid,         label: 'Routines' },
  { id: 'log',       icon: FiPlus,         label: '',         isMain: true },
  { id: 'shop',      icon: FiShoppingBag,  label: 'Shop' },
  { id: 'profile',   icon: FiUser,         label: 'Profile' },
];

export default function BottomNav({ current, onChange }) {
  return (
    <div className="flex-shrink-0 glass-panel z-50 relative">
      <div className="flex justify-around items-end px-2 pt-3 pb-6">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            className="flex flex-col items-center justify-end relative"
            style={{ minWidth: 56 }}
          >
            {tab.isMain ? (
              <motion.div
                whileTap={{ scale: 0.95 }}
                className="w-14 h-14 rounded-full flex items-center justify-center shadow-lg mb-1"
                style={{ background: 'linear-gradient(135deg, #f9a8d4, #c084fc, #818cf8)', marginTop: -20 }}
              >
                <SafeIcon icon={tab.icon} className="text-2xl text-white" />
              </motion.div>
            ) : (
              <div
                className={`flex flex-col items-center gap-1 px-2 py-1 rounded-xl transition-colors ${
                  current === tab.id
                    ? 'text-slate-900'
                    : 'text-slate-400 hover:text-slate-600'
                }`}
              >
                <SafeIcon icon={tab.icon} className="text-xl" />
                <span className="text-xs font-medium font-sans">{tab.label}</span>
                {current === tab.id && (
                  <div className="w-1 h-1 rounded-full bg-slate-900 mt-0.5 absolute bottom-[-6px]" />
                )}
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
